export enum SequenceExecutionStateString {
  COMPLETED = 'completed',
  NOT_STARTED = 'not started',
}

export type SequenceExecutionState = SequenceExecutionStateString | number;

export interface ExecutionState {
  sequences: {
    [key: string]: SequenceExecutionState;
  }
}

